module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":"Broadcast to drivers","placeholder":"Choose drivers","driverNotContactable":"One or more driver is missing contact info"},"no":{"label":"Kringkast til sjåfører","placeholder":"Velg sjåfører","driverNotContactable":"En eller flere sjåfører mangler kontaktinfo"}}')
  delete Component.options._Ctor
}
